import ManualVideoScreen from "../../screens/ManualVideo/ManualVideoScreen.jsx";

const ManualVideoContainer = () => {
  return <ManualVideoScreen />;
};

export default ManualVideoContainer;
